import {
  getFallbackCoordinates,
  type Coordinates,
} from '@modules/dashboard/hooks/geolocation_shared';

export { getFallbackCoordinates, type Coordinates };

export function getCurrentCoordinates(): Promise<Coordinates | null> {
  return new Promise((resolve) => {
    if (typeof navigator === 'undefined' || !navigator.geolocation) {
      resolve(null);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      },
      () => resolve(null)
    );
  });
}
